<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>공영주차장</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">공영주차장</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">주차요금 감면안내</p>
          <ul class="depth">
            <li><router-link to="/map" title="노외주차장 검색">노외주차장 검색</router-link></li>
            <li><router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link></li>
            <li><router-link to="/parkfeereduction" title="주차요금 감면안내">주차요금 감면안내</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">주차요금 감면안내</h3>
        <article>
          <div class="infoBox">
            <ul class="bullet arrowType">
              <li>
                주차요금의 이중감면은 하지 아니하며, 감면받고자 할 경우에는
                <em class="underline">주차요금 납부(또는 출차)시 감면 대상임을 증명한 경우만 가능합니다.</em>
              </li>
              <li>이미 납부한 주차요금에 대하여 아래의 감면내용을 적용하여 소급해서 환불하여 주지 않습니다.</li>
            </ul>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 100퍼센트 감면</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  주차요금 100퍼센트 감면 안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 20%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">감면대상</th>
                    <th scope="col">확인방법</th>
                    <th scope="col">요금 또는 비율</th>
                    <th scope="col">1일 주차권</th>
                    <th scope="col">월정기권</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="txt-left">
                      1.「도로교통법」제2조제22호에 따른긴급자동차 (단, 노상에 한함)</td>
                    <td>육안식별</td>
                    <td rowspan="12" colspan="3">전액면제</td>
                  </tr>

                  <tr>
                    <td class="txt-left">
                      2.「교통약자의 이용편의 증진법」제16조에 따른 교통약자이동지원센터 차량</td>
                    <td>육안식별</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      3.「장애인복지법」제81조에 따른 장애인 심부름센터 차량 및 「장애인복지법」제63조에 따른 콜승합차
                    </td>
                    <td>육안식별</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      4.「이천시 지역 주둔 군부대 지원에 관한 조례」제2조에서 정한 군부대 관용차량
                    </td>
                    <td>육안식별</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      5.「이천시 명예시민증 수여 및 예우에 관한 조례」에서 정한 명예시민증을 제시한 자가 본인의
                      자동차를 직접 운전하거나 동승한 차량
                    </td>
                    <td>이천시 명예시민증</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      6. 국세청장·경기도지사의 모범·유공납세자 및 이천시장의 모범·유공·성실납세자 인증서 및 인증필증을 부착한 차량
                    </td>
                    <td>성실납세자 인증서
                      및 인증필증</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      7.「이천시 자랑스러운 이천인상 조례」에서 정한 이천
                      인증을 제시한 자가 본인의 자동차를 직접 운전하거
                      나 동승한 차량
                    </td>
                    <td>이천인증</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      8. 「국가보훈 기본법」에 따른 국가보훈대상자
                      (「제대군인지원에 관한 법률」에 따른 국가보훈대상자는 제외한다)의 자가운전 차량이면서
                      65세 이상의 경로우대자 본인을 동시에 충족하는 경우
                    </td>
                    <td>국가유공자증서 및 자동차등록증</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 면제(감면) 및 추가 이용시 일부 감면 대상</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  주차요금 면제(감면) 및 추가 이용시 일부 감면 대상 안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 20%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">감면대상</th>
                    <th scope="col">확인방법</th>
                    <th scope="col">요금 또는 비율</th>
                    <th scope="col">1일 주차권</th>
                    <th scope="col">월정기권</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="txt-left">
                      1. 본인의 자동차를 직접 운전하거나 장애정도가 심해 동승하고 타인으로 하여금 대리 운전하는 경우
                      (장애정도가 심한 장애인)
                    </td>
                    <td>
                      장애인등록증<br />
                      및 자동차 등록증
                    </td>
                    <td>2시간 면제 후<br />50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      2. 본인의 자동차를 직접 운전하거나 장애정도가 심해 동승하고 타인으로 하여금 대리 운전하는 경우
                      (장애정도가 심하지 않은 장애인)
                    </td>
                    <td>
                      장애인등록증<br />
                      및 자동차 등록증
                    </td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      3.「경기도 자원봉사활동 지원 조례」 제17조에 따라 경기도에서 우수자원봉사자로 선정되어 “경기도
                      우수 자원봉사증”을 소지한 이천시민 중 본인 차량을 직접 운전하는 차량 (단, 출차시 현장에서
                      감면대상임을 제시한 자에 한한다.)
                    </td>
                    <td>
                      경기도 우수자원<br />
                      봉사증(이천시민)
                    </td>
                    <td>1시간 무료 후<br />50% 감면</td>
                    <td>-</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      4.「전통시장 및 상점가 육성을 위한 특별법」제19조에 따라 전통시장 주변 공영주차장으로 전통시장 및 상점가에서 상품을 구매하여 점포주가 발급하는 영수증 또는 같은 법 시행령 제3조에 따른 상인조직에서 발급한 증표를 제시한 자
                    </td>
                    <td>
                      간이 영수증 또는 전통시장용 주차권
                    </td>
                    <td>1시간 무료</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      5. 「대기환경보전법 시행령」제1조의2제1호에 따른 제1종 전기자동차, 태양광자동차 및 수소전기자동차
                    </td>
                    <td>자동차등록증
                      또는 육안식별</td>
                    <td>1시간 면제 후<br />50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      6. 주차장 조성으로 인하여 건축물과 접한 도로가 「도로교통법」 제32조에 따른 주정차금지구역 신규시행일 기준으로 노외주차장(주차대수 300대 이상)과 접한 가구 또는 사업장 차량(다만, 구체적인 도로면 접한 필지는 별도로 선정하고 이천시보에 공고한다.)
                      <br/>
                      - 「주민등록법」 제16조 규정에 따라 전입신고된 가구 당 1대
                      <br/>
                      .- 「부가가치세법」 제8조 규정에 따라 사업자등록된 사업
                      장 당 1대
                      <br/>
                      ※ 한 건축물의 가구 수가 2가구 이상일 경우 2가구만 인정
                      <br/>
                      ※ 한 건축물의 사업장 수가 2사업장 이상일 경우
                      2사업장만 인정
                    </td>
                    <td>주민등록등본
                      사업자등록증</td>
                    <td>-</td>
                    <td>-</td>
                    <td>50% 감면<br/>(우선 배정)</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      7.「국가유공자 등 예우 및 지원에 관한 법률」에 의한 국가유공자 또는 그 유족 중 국가유공자 증서를 소지한 자
                    </td>
                    <td>
                      국가유공자 증서<br />
                      및 자동차 등록증
                    </td>
                    <td>4시간 면제 후<br>50%감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      8.「참전 유공자예우에 관한 법률」에 의한 참전유공자 증서를 소지한 자</td>
                    <td>
                      참전유공자 증서<br />
                      및 자동차 등록증
                    </td>
                    <td>4시간 면제 후<br>50%감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      9.「고엽제후유의증 등 환자지원 및 단체설립에 관한 법률」 제2조제3호에 따른 고엽제후유의증환자로서 같은 법 제4조 및 제7조제5항에 따라 등록된 자
                    </td>
                    <td>
                      고엽제후유등록증<br />
                      및 자동차 등록증
                    </td>
                    <td>4시간 면제 후<br>50%감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      10.「5·18민주유공자예우 및 단체설립에 관한 법률」에 따른 5·18민주화운동부상자(본인의 자동차를 직접 운전하거나 장애정도가 심하여 타인이 대신 운전하고 본인이 차량에 동승하는 경우를 포함한다)
                    </td>
                    <td>
                      5.18민주유공 증서<br />
                      및 자동차 등록증
                    </td>
                    <td>4시간 면제 후<br>50%감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      11.「의사상자 등 예우 및 지원에 관한 법률」에 따른 의사상자 증서(유족증 포함)를 소지한 자
                    </td>
                    <td>
                      의사상자 증서 또는<br />
                      유족증서 및 자동차 등록증
                    </td>
                    <td>4시간 면제 후<br>50%감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>                  
                </tbody>
              </table>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 50퍼센트 감면</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  주차요금 50퍼센트 감면 안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 20%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">감면대상</th>
                    <th scope="col">확인방법</th>
                    <th scope="col">요금 또는 비율</th>
                    <th scope="col">1일 주차권</th>
                    <th scope="col">월정기권</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="txt-left">1.「자동차관리법 시행규칙」제2조 규정에 의한 경형자동차(배기량 1천cc 미만)</td>
                    <td>자동차등록증 또는 육안식별</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      2.「수도권 대기환경개선에 관한 특별법」제28조 및 동법 시행규칙 제38조의 규정에 의한 저공해자동차
                      표지를 부착한 차량
                    </td>
                    <td>저공해자동차 표시증<br />육안식별</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      3. 2자녀 이상 다자녀임을 증명할 수 있는 서류, 카드
                      등을 제시한 세대의 차량
                    </td>
                    <td>
                      주민등록등본
                      또는 도민카드 등
                    </td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      4.「모자보건법」제2조제1호 규정에 따라서 임산부 모자 보건수첩, 임산부자동차표지 등 임산부 증명자료
                      제시한 운전자 차량
                    </td>
                    <td>모자보건수첩<br />임산부자동차 표시증</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      5.「노인복지법」제26조 제1항의 규정에 의한 65세 이상의 경로우대자 본인이 운전하는 차량
                    </td>
                    <td>운전자 신분증</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      6.「이천시 자원봉사활동 지원에 관한 조례」제3조제1호의 규정에 의한 자원봉사활동에 직접 사용하는
                      차량
                    </td>
                    <td>자동차등록증 또는 육안식별</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      7.「이천시 병역명문가 예우 및 지원에 관한 조례」제6조제1항제1호에 따라 병무청에서 발행한
                      병역명문가증과 주소가 기입된 신분증을 제시한 운전자 차량
                    </td>
                    <td>병역명문가증 및 본인 신분증</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                  <tr>
                    <td class="txt-left">
                      8.  「국민기초생활 보장법」 제2조제2호 및 제10호에 따라
                      시장이 발행한 증명서를 제출하는 수급자 및 차상위계
                      층 자가운전차량
                    </td>
                    <td>이천시 증명서</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                    <td>50% 감면</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 30퍼센트 감면</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  주차요금 30퍼센트 감면 안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 20%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">감면대상</th>
                    <th scope="col">확인방법</th>
                    <th scope="col">요금 또는 비율</th>
                    <th scope="col">1일 주차권</th>
                    <th scope="col">월정기권</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="txt-left">1. 승용차 요일제 및 함께 타기 표지부착 차량</td>
                    <td>요일제 표시증 육안식별</td>
                    <td>30% 감면</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">주차요금 2,000원 감면</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table blue-table col20">
              <table>
                <caption>
                  주차요금 2,000원 감면 안내 테이블
                </caption>
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 20%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">감면대상</th>
                    <th scope="col">확인방법</th>
                    <th scope="col">요금 또는 비율</th>
                    <th scope="col">1일 주차권</th>
                    <th scope="col">월정기권</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="txt-left">
                      1. 「공직선거법」제2조 및「지방교육자치에 관한 법률」 제8조, 제22조의 규정에 의한 선거에 있어서
                      투표에 참여한 자로서 선거관리위원회가 발급한 투표확인증을 제출한 사람에 대하여는 주차요금
                      2,000원을 감면한다.<br />
                      (단, 투표확인증의 유효기간은 당해 선거의 선거일후 1개월 까지로 한다.)
                    </td>
                    <td>
                      선관위가 발급한<br />
                      투표확인증
                    </td>
                    <td>2,000</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
